import { resolveSyncIfLoadedOrThrow } from "@avensia/nitro5-scope";
export default (componentName) => {
    const Component = resolveSyncIfLoadedOrThrow(componentName);
    if (!Component) {
        if (process.env.NODE_ENV !== "production") {
            throw new Error("Component '" +
                componentName +
                "' does not exist. " +
                "Did you forget to build the frontend or run nitro.cmd frontend:build-component-registry?");
        }
        else {
            throw new Error("Component '" + componentName + "' does not exist.");
        }
    }
    return Component;
};
export function isComponentFor(componentName, compareTo) {
    return (componentName === compareTo);
}
